<template>
  <div v-if="styleType === 'normal'">
    <div v-for="(option, index) in inputData.checkbox" v-bind:key="index">
      <label>
        <input
          type="checkbox"
          v-bind:name="inputData.label"
          v-bind:value="option.value"
          v-bind:checked="value.indexOf(option.value) >= 0"
          v-on:click="updateValue(option.value)">
        <span class="text">{{ option.value }}</span>
      </label>
    </div>

    <div class="validation-text" v-if="status === true">
      {{ t.pleaseSelectOption }}
    </div>
  </div>
  <div v-else-if="styleType === 'material'">
    <div v-for="(option, index) in inputData.checkbox" v-bind:key="index">
      <label class="rp-material-checkbox">
        <input
          type="checkbox"
          v-bind:name="inputData.label"
          v-bind:value="option.value"
          v-bind:checked="value.indexOf(option.value) >= 0"
          v-on:click="updateValue(option.value)">
        <span class="text">{{ option.value }}</span>
      </label>
    </div>
  </div>
</template>

<script>
import { Cart } from '@/store/Cart'

export default {
  name: 'CheckboxInput',
  props: {
    value: Array,
    styleType: {
      type: String,
      default: 'normal'
    },
    inputData: {
      type: Object,
      default: () => {
        return {
          id: 0,
          type: 'checkbox',
          label: 'checkbox1',
          required: '0',
          placeholder: 'placeholder',
          checkbox: [
            {
              id: 1,
              value: 'Option1'
            },
            {
              id: 2,
              value: 'Option2'
            }
          ]
        }
      }
    }
  },
  data () {
    return {
      status: false
    }
  },
  computed: {
    t () {
      if (Cart.getLocale() == 'en') {
        return {
          pleaseSelectOption: 'Please select an option'
        }
      } else if (Cart.getLocale() == 'th') {
        return {
          pleaseSelectOption: 'กรุณาเลือกรายการ'
        }
      } else if (Cart.getLocale() == 'vi') {
        return {
          pleaseSelectOption: 'Vui lòng chọn ít nhất một mục'
        }
      }
    }
  },
  methods: {
    validateInput () {
      return this.validateInputProcess(this.value)
    },
    updateValue (value) {
      if (this.value.indexOf(value) >= 0) {
        this.value.splice(this.value.indexOf(value), 1)
      } else {
        this.value.push(value)
      }
      this.$emit('input', this.value)
      this.validateInputProcess(this.value)
    },
    validateInputProcess (value) {
      let result = true

      if (value.length === 0 && this.inputData.required === '1') {
        this.status = true
        result = false

        return result
      } else {
        this.status = false
      }

      return result
    }
  }
}
</script>

<style lang="scss" scoped>
input {
  position: absolute;
  margin-top: 3px;
}
.text {
  width: 90%;
  overflow-wrap: break-word;
  display: inline-block;
  margin-left: 20px;
}
.validation-text {
  color: red;
  font-size: 0.75em;
}
</style>



// WEBPACK FOOTER //
// src/components/share/form/CheckboxInput.vue